export default "__VITE_ASSET__6WG55hsb__"